export default "__VITE_ASSET__c146856d__"